// extracted by mini-css-extract-plugin
module.exports = {"aboutSection":"about-module--about-section--KsRJN","secondary":"about-module--secondary--2qQ94","description":"about-module--description--4qvPd"};